import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Header from "../../../../components/Header";
import Footer from "../../../../components/Footer";
import "../../styleAllServices.css";

export default function GardenCleanup() {
  
  const location = useLocation();

  // Meta Tag changes
  useEffect(() => {
    const canonicalUrl = `https://bur-han.ca${location.pathname}`;
    const linkTag = document.querySelector('link[rel="canonical"]');
    if (linkTag) {
      linkTag.setAttribute("href", canonicalUrl);
    } else {
      const newLinkTag = document.createElement("link");
      newLinkTag.setAttribute("rel", "canonical");
      newLinkTag.setAttribute("href", canonicalUrl);
      document.head.appendChild(newLinkTag);
    }

    const newTitle = "Garden Cleanup | Landscaping Services at BUR-HAN Garden & Lawn Care";
    document.title = newTitle;

    const newDescription =
    "Get your property ready for winter with our Garden Cleanup services in Vancouver, British Columbia. BUR-HAN Garden & Lawn Care offers expert leaf removal, lawn care, and garden preparation to keep your outdoor space pristine through the colder months.";
    const descriptionMetaTag = document.querySelector('meta[name="description"]');
    if (descriptionMetaTag) {
      descriptionMetaTag.setAttribute("content", newDescription);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "description");
      newMetaTag.setAttribute("content", newDescription);
      document.head.appendChild(newMetaTag);
    }

    const newKeywords = [
      "Garden cleanup Vancouver, Leaf removal services North Vancouver, Fall lawn care West Vancouver, Vancouver leaf raking services, Residential leaf cleanup Burnaby, Leaf cleanup company Vancouver BC, Fall yard clean-up West Vancouver",
    ].join(", ");
    const keywordsMetaTag = document.querySelector('meta[name="keywords"]');
    if (keywordsMetaTag) {
      keywordsMetaTag.setAttribute("content", newKeywords);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "keywords");
      newMetaTag.setAttribute("content", newKeywords);
      document.head.appendChild(newMetaTag);
    }

    const ogTitleTag = document.querySelector('meta[property="og:title"]');
    if (ogTitleTag) {
      ogTitleTag.setAttribute("content", newTitle);
    } else {
      const newOgTitleTag = document.createElement("meta");
      newOgTitleTag.setAttribute("property", "og:title");
      newOgTitleTag.setAttribute("content", newTitle);
      document.head.appendChild(newOgTitleTag);
    }

    const ogDescriptionTag = document.querySelector('meta[property="og:description"]');
    if (ogDescriptionTag) {
      ogDescriptionTag.setAttribute("content", newDescription);
    } else {
      const newOgDescriptionTag = document.createElement("meta");
      newOgDescriptionTag.setAttribute("property", "og:description");
      newOgDescriptionTag.setAttribute("content", newDescription);
      document.head.appendChild(newOgDescriptionTag);
    }
  }, [location.pathname]);

  return (
    <div className="wrapper">
      <Header />
      <div className="serviceItemsHeader">
        <h1 data-aos="zoom-in">Garden Cleanup</h1>
      </div>
      <div className="serviceItemsMain">
        <h2 data-aos="fade-down">
          "Enhance the beauty and function of your outdoor space with our expert
          garden cleanup services."
        </h2>
        <div className="row justify-content-md-center mb-5 ">
   
          <div
            className="col-lg-3 md-3 col-sm-6 col-xs-12"
            data-aos="fade-down"
          >
            <a href="/services/garden-cleanups/garden-cleanup/pruning-shearing">
              <div className="servicesCard transfNone">
                <div className="cover item-j">
                  <h3>Pruning/Shearing</h3>
                </div>
              </div>
            </a>
          </div>
          <div
            className="col-lg-3 md-3 col-sm-6 col-xs-12"
            data-aos="fade-down"
          >
            <a href="/services/garden-cleanups/garden-cleanup/blackberry-removal">
              <div className="servicesCard transfNone">
                <div className="cover item-k ">
                  <h3>Blackberry Removal</h3>
                </div>
              </div>
            </a>
          </div>
        </div>
        <hr style={{ marginBottom: "2vw" }} />

        <section className="project-text" data-aos="fade-up">
          <div className="container">
            <h2>Expert Garden Cleanup Services Across Greater Vancouver</h2>
            <p>
              A beautiful garden requires more than just regular watering — it needs structured pruning, shearing, and the removal of invasive plants to stay healthy and presentable. BUR-HAN Garden & Lawn Care's garden cleanup team provides hands-on care for residential and commercial properties throughout Vancouver, North Vancouver, West Vancouver, Burnaby, Coquitlam, and beyond.
            </p>
            <p>
              Our <strong>pruning and shearing service</strong> keeps hedges, shrubs, and ornamental trees shaped, healthy, and growing at their best. Properly timed pruning encourages vigorous new growth, improves airflow through dense foliage, and maintains the clean, intentional look that sets a well-cared-for property apart. Our crews are trained to prune each species correctly — removing the right amount at the right time of year for optimal plant health.
            </p>
            <p>
              <strong>Blackberry removal</strong> is one of the most demanding cleanup tasks on the North Shore and across Greater Vancouver. Himalayan blackberry is an aggressive invasive species that spreads rapidly, damages fences and structures, and is nearly impossible to control without professional equipment and know-how. Our team uses targeted removal techniques to clear established blackberry canes and root systems, giving your garden back its space and preventing regrowth.
            </p>
            <p>
              Whether you need a one-time cleanup before selling your home or ongoing seasonal garden care, BUR-HAN's experienced crews deliver thorough, reliable results. Contact us today to schedule a garden cleanup assessment for your property.
            </p>
          </div>
        </section>

        <div className="container-grubgone">
          <div className="row">
    
        <section className="lawnCareLinks" data-aos="fade-up">
          <h2>More Garden Cleanup Services</h2>
          <div className="lawnCareLinks-grid">
            <a href="/services/garden-cleanups"><strong>Garden Cleanups</strong><span>All cleanup services</span></a>
            <a href="/services/garden-cleanups/leaf-cleanup"><strong>Leaf Cleanup</strong><span>Professional leaf removal</span></a>
            <a href="/services/garden-cleanups/garden-cleanup/pruning-shearing"><strong>Pruning & Shearing</strong><span>Shrub and hedge care</span></a>
            <a href="/services/garden-cleanups/garden-cleanup/blackberry-removal"><strong>Blackberry Removal</strong><span>Invasive plant control</span></a>
          </div>
        </section>
        <div className="secondBanner">
              <div className="container" data-aos="fade-down">
                <div className="row">
                  <div className="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-8">
                    <h3 className="grubBannerTitle">
                      Get Ready for Fall with Our Professional Leaf Cleanup
                      Services
                    </h3>
                    <p className="grubBannerText">
                      Don't let the falling leaves take over your lawn. Let
                      BUR-HAN Garden & Lawn Care handle the hard work for you!{" "}
                      <span style={{ color: "var(--yellow-color)" }}>
                        CONTACT US TODAY
                      </span>{" "}
                      to schedule your leaf cleanup and ensure your property
                      stays beautiful throughout the fall season.{" "}
                    </p>{" "}
                  </div>
                  <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-4">
                    <div className="call-to-action text-right">
                      <a
                        href="/contact-us"
                        className="get-a-quote grubBannerButton"
                      >
                        Contact Us
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
